import React from 'react';
import { JoinerEditorTabs, JoinerEditorHeader, JoinerEditorButtons } from '../joinerEditor';
import Edit from '../editForms/edit/OpenTextEdit';
import AttachMedia from '../editForms/media/AttachMedia';
import Options from '../editForms/options/openTextOptions';
import Timing from '../editForms/timing/Timing';
import Rules from '../editForms/rules/Rules';

class OpenTextEditor extends React.Component {
  render() {
    const { props } = this;
    const { isEmailCollector } = props.joinerInfo;
    return (
      <>
        <JoinerEditorTabs
          tabs={props.tabs}
          joinerInfo={props.joinerInfo}
          hideMedia={props.isScreener}
          hideOptions={isEmailCollector}
          hideRules={isEmailCollector}
          hideTiming={props.isScreener || isEmailCollector}
        />
        <div className="joiner-editor">
          <JoinerEditorHeader {...props} />
          <div className="joiner-editor-form">
            <Edit {...props} />
            <AttachMedia {...props} />
            <Options {...props} />
            <Timing {...props} />
            <Rules {...props} />
          </div>
          <JoinerEditorButtons
            toggle={props.toggle}
            saveEnabled={props.saveEnabled}
            saveJoiner={props.saveJoiner}
            readOnly={props.readOnly}
          />
        </div>
      </>
    );
  }
}

export default OpenTextEditor;
